import {
	LinkExpirationMeaning,
	Permission,
	PermissionType,
	PhoenixFolderShare
} from 'phoenix/domain';
import { Patchable } from 'util/domain';
import * as mergeWith from 'lodash.mergewith';

const NullPhoenixFolderShare:PhoenixFolderShare = {
	AccessCodeRequired: null,
	AuthToken: null,
	AuthenticationRequired: null,
	CustomEmailText: null,
	DateExpires: null,
	DateShared: null,
	Embedded: {
		Permissions: null,
		Recipients: null
	},
	ExpirationValue: null,
	ExpireMeaning: null,
	FolderName: null,
	IsExpired: null,
	Links: {
		ActivityUri: null,
		RevokeUri: null,
		Self: null,
		Update: null,
		Validate: null,
	},
	Password: null,
	PasswordRequired: null,
	ReferenceString: null,
	Sender: null,
	ShareId: null,
	Status: null
}

export class ShaasFolderShare extends Patchable<PhoenixFolderShare> {
	public dateExpires:Date = this.source.DateExpires;
	public emailText:string = this.source.CustomEmailText;
	public recipients:string[] = this.source.Embedded.Recipients || [];
	public preventDownload = false;

	constructor(
		source:PhoenixFolderShare = angular.copy(NullPhoenixFolderShare)
	) {
		super(source);
	}

	public toApi():PhoenixFolderShare {
		const viewPermissions:Permission[] = [
			{ PermissionValue: PermissionType.READ, Allow: true, Deny: false },
			{ PermissionValue: PermissionType.READDOC, Allow: true, Deny: false },
			{ PermissionValue: PermissionType.READFOLD, Allow: true, Deny: false },
			{ PermissionValue: PermissionType.LISTFOLD, Allow: true, Deny: false }
		];
		const downloadPermissions:Permission[] = [
			{ PermissionValue: PermissionType.DOWNLOAD, Allow: true, Deny: false },
			{ PermissionValue: PermissionType.DNLDDOC, Allow: true, Deny: false },
			{ PermissionValue: PermissionType.DNLDFOLD, Allow: true, Deny: false }
		];
		
		return mergeWith(
			angular.copy(this.source),
			{
				CustomEmailText: this.emailText,
				Embedded: {
					Permissions: viewPermissions.concat(this.preventDownload ? [] : downloadPermissions),
					Recipients: this.recipients
				},
				DateExpires: this.dateExpires
			} as PhoenixFolderShare,
			(objValue, srcValue) => {
				if (angular.isArray(objValue)) {
					return objValue.concat(srcValue);
				}
			}
		)
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/shaas-folder-share.ts